import axios from "@/axios"; 
import axiosSync from "@/axiosSync"; 
const API_URL = process.env.VUE_APP_API_BASE_URL;

export function useOltDetailsApi() {
  async function oltDetails(id) {
    try {
      const response = await axios.get(`${API_URL}/get-data-oltpage/?oltid=${id}`); 
      return response.data; 
    } catch (error) {
      console.error("Error retrieving ping data:", error);
      throw error;
    }
  }
  async function oltClear(id) {
    try {
      const response = await axios.delete(`${API_URL}/delete-olt-data/${id}/`); 
      return response.data; 
    } catch (error) {
      console.error("Error retrieving ping data:", error);
      throw error;
    }
  }
  async function oltSync(id,brand,file,mode) {
    try {
      const response = await axiosSync.get(`/run?oltid=${id}&oltbrand=${brand?.toLowerCase()}&mode=${mode?.toLowerCase()}&file=${file}&url=${process.env.VUE_APP_API_BASE_URL}`); 
      return response.data; 
    } catch (error) {
      console.error("Error retrieving ping data:", error);
      throw error;
    }
  }
  async function oltSyncAll(id,brand,mode) {
    try {
      const response = await axiosSync.get(`/run?oltid=${id}&oltbrand=${brand?.toLowerCase()}&mode=${mode?.toLowerCase()}&url=${process.env.VUE_APP_API_BASE_URL}`); 
      return response.data; 
    } catch (error) {
      console.error("Error retrieving ping data:", error);
      throw error;
    }
  }
  async function oltSyncList() {
    try {
      const response = await axiosSync.get(`/script-list`); 
      return response.data; 
    } catch (error) {
      console.error("Error retrieving ping data:", error);
      throw error;
    }
  }
  async function oltSyncStatus(id) {
    try {
      const response = await axiosSync.get(`/status?oltid=${id}&url=${process.env.VUE_APP_API_BASE_URL}`); 
      return response.data; 
    } catch (error) {
      console.error("Error retrieving ping data:", error);
      throw error;
    }
  }
  async function oltReset(olt) {
    try {
      const response = await axios.get(`/api-olt-control/?restart=${olt}`); 
      return response.data; 
    } catch (error) {
      console.error("Error retrieving ping data:", error);
      throw error;
    }
  }
  async function oltStatus(olt) {
    try {
      const response = await axios.get(`/api-olt-control/?status=${olt}`); 
      return response.data; 
    } catch (error) {
      console.error("Error retrieving ping data:", error);
      throw error;
    }
  }
  async function oltVideo() {
    try {
      const response = await axios.get(`/video-link-api/`); 
      return response.data; 
    } catch (error) {
      console.error("Error retrieving ping data:", error);
      throw error;
    }
  }
  async function oltPPPOEID(id,port) {
    try {
      const response = await axios.get(`/api/port-data/onu-loss/?oltid=${id}&port_number=${port}`); 
      return response.data; 
    } catch (error) {
      console.error("Error retrieving ping data:", error);
      throw error;
    }
  }
  return {
    oltDetails,
    oltClear,
    oltSync,
    oltSyncAll,
    oltSyncList,
    oltSyncStatus,
    oltReset,
    oltStatus,
    oltVideo,
    oltPPPOEID
  };
}